/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
var transform = function transform(_ref) {
  var _ref$FailureMessageBe = _ref.FailureMessageBean,
      failureMessage = _ref$FailureMessageBe.failureMessage,
      category = _ref$FailureMessageBe.category,
      displayLocation = _ref$FailureMessageBe.displayLocation,
      viewName = _ref$FailureMessageBe.viewName;
  return {
    FailureMessageBean: {
      globalMessages: [{
        message: failureMessage,
        level: category,
        messagePlacement: displayLocation,
        viewName: viewName
      }]
    }
  };
};

export default (function (failureMessageBean) {
  return failureMessageBean.FailureMessageBean.hasOwnProperty('failureMessage') ? transform(failureMessageBean) : failureMessageBean;
});